export const EXPERIMENT_NO_ADS = "noAds";
export const EXPERIMENT_SFW = "sfw";
export const EXPERIMENT_CFP = "cfp";
export const EXPERIMENT_TRENDING_CURATION = "025-trending-curation-experiment";
export const EXPERIMENT_CONTEXT_BASED_RECOMMENDATIONS = "008-context-based-recommendations-experiment";
export const EXPERIMENT_TRENDING_NICHES = "023-trending-niches-experiment";
export const EXPERIMENT_HOT_FEED_RANDOMISATION = "024-hot-feed-randomisation-experiment";

export const VARIANT_CONTROL = "control";
/* eslint-disable-next-line */
export const VARIANT_TREATMENT = "treatment";
export const VARIANT_OFF = "off";

export const VARIANT_ESTABLISHED = "established";

export const VARIANT_SEARCH = "search";
const VARIANT_TAG = "tag";

export const VARIANT_RANDOMISED_30 = "randomised_30";
export const VARIANT_RANDOMISED_50 = "randomised_50";

export const EXPERIMENT_COVERAGE_MAP: {[key: string]: number} = {
  [EXPERIMENT_TRENDING_CURATION]: 0.06,
  [EXPERIMENT_CONTEXT_BASED_RECOMMENDATIONS]: 0.06,
  [EXPERIMENT_TRENDING_NICHES]: 0.06,
  [EXPERIMENT_HOT_FEED_RANDOMISATION]: 0.06,
};

export const TRENDING_CURATION_VARIANT_LIST = [
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_ESTABLISHED,
    value: VARIANT_ESTABLISHED
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];

export const TRENDING_NICHES_VARIANT_LIST = [
  {
    label: VARIANT_SEARCH,
    value: VARIANT_SEARCH
  },
  {
    label: VARIANT_TAG,
    value: VARIANT_TAG
  },
];

export const HOT_FEED_RANDOMISATION_VARIANT_LIST = [
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: "randomised 30",
    value: VARIANT_RANDOMISED_30
  },
  {
    label: "randomised 50",
    value: VARIANT_RANDOMISED_50
  }
];

export const DEFAULT_VARIANT_LIST = [
  {
    label: VARIANT_TREATMENT,
    value: VARIANT_TREATMENT
  },
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  },
  {
    label: VARIANT_OFF,
    value: VARIANT_OFF
  },
];
